import React from 'react';
import DragNDropColumns, {
  EnumPosition,
} from 'src/components/DragNDropColumns';
// import WarningIcon from 'src/components/Icon/Warning';
// import css from './css.module.less';
import {
  //   Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Field } from 'src/components/RcForm';
//import { sectionProps } from 'src/tools/constant';
import { tacs as tcK } from 'src/tools/contentModulesFieldName';
//import ProductDisplayInRow from '@/src/components/DragRowDisplay/ProductDisplayInRowShort';
import { get, uniq } from 'lodash';
//import { ErrorDisplay2 } from 'src/constrains/SalesChannelPreviewPageComponents/CollapseErrors';
//import { checkResponsiveProductTab } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import css from './css.module.less';

import TextOnlyContainer from 'src/components/DragRowDisplay/TextOnly';
import Tooltip, {
  NoWrapContainer,
} from 'src/components/GlobalTooltip/GlobalTooltip';
import { Tag } from 'src/components/Tags/Tags';
import { checkResponsiveSubscription } from 'src/constrains/SalesChannelContent-Revamp/ModuleList/validator';
import TCModals from 'src/constrains/TermsAndConditionsSelection';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const TermsAndConditions = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { checkTacs } = checkResponsiveSubscription();
  const {
    //  disabled,
    onSort,
    onDelete,
    breakpoint,
    tcsOptions = [],
    draggableId,
    onReselect,
    disabled,
  } = props;
  const [tcVisible, setTcVisible] = React.useState(false);

  return (
    <Section
      {...{ size: 'small', bottomBorder: false, style: { padding: 0 } }}
      id={draggableId}>
      <Field name={[tcK]}>
        {(p, m) => {
          const { value, onChange } = p;

          const tcChildGenerate = (data, index) => {
            const { name } = data;
            return <TextOnlyContainer name={name} />;
          };

          const handleOnModalCancel = () => {
            setTcVisible(false);
          };

          const handleItemOnSort = (obj) => {
            const { data } = obj;
            const { newIndex, oldIndex } = data || {};
            if (onSort) {
              onSort(value, onChange, oldIndex, newIndex);
            }
          };
          const handleOnItemDelete = (index) => {
            if (onDelete) {
              onDelete(value, onChange, index);
            }
          };
          const getAllAttributes = () => {
            return uniq(
              (value || []).reduce((pre, i) => {
                const _r = [...pre, ...(i.consentAttributes || [])];
                return _r;
              }, []),
            );
          };

          const handleOnReselect = (tcs) => {
            const _tc = tcs.map((i) => {
              const { uuid } = i;
              return { ...i, draggableId: uuid };
            });
            if (onReselect) {
              onReselect(value, onChange, _tc);
            }
          };

          const generateErrorText = () => {
            const res = checkTacs(value, { breakpoint });
            const hasError = get(res, 'hasError');
            const errors = get(res, 'errors');
            if (hasError) {
              return errors;
            } else {
              return [];
            }
          };

          return (
            <React.Fragment>
              {tcVisible && (
                <TCModals
                  tcs={tcsOptions}
                  selectedItems={value || []}
                  onOk={handleOnReselect}
                  onCancel={handleOnModalCancel}
                  visible={tcVisible}
                />
              )}
              <DragNDropColumns
                errorInTitle={generateErrorText().join(' ')}
                subTitle={getI18n(
                  'salesChannelContent.index.termsAndConditionsSubTitle',
                )}
                titleRightTextClassName={css.editContainer}
                //displayWarningModalWhenDeleting
                hideTitleRightFunction
                titleRightText={getI18n('general.edit')}
                childGenerate={tcChildGenerate}
                onDelete={disabled ? null : handleOnItemDelete}
                data={value || []}
                hideAdd={disabled}
                disabled={disabled}
                onAdd={() => setTcVisible(true)}
                droppableId={`${draggableId}TCDropArea`}
                onSort={handleItemOnSort}
                addTextPosition={EnumPosition.bottom}
                addText={`+ ${getI18n(
                  'salesChannelContent.index.addTermsAndConditions',
                )}`}
              />
              <Section className={css.attContainer}>
                <div className={css.title}>
                  {getI18n('general.consentAttribute')}
                </div>
                {getAllAttributes().map((i: string) => {
                  return (
                    <Tag className={css.tag} closable={false} key={6}>
                      <NoWrapContainer>
                        <Tooltip title={i}>{i}</Tooltip>
                      </NoWrapContainer>
                    </Tag>
                  );
                })}
              </Section>
            </React.Fragment>
          );
        }}
      </Field>
    </Section>
  );
};
export default TermsAndConditions;
